import React from 'react';

const ChackedIcon = ({ width = 12, height = 12, fill = "#fff" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 5.06452 8.25421 C 3.5676 8.25421 2.40283 6.76506 2.06412 6.19169 C 1.93487 5.97398 2.00729 5.69302 2.225 5.56423 C 2.44316 5.43452 2.72412 5.50785 2.85245 5.7251 C 3.56516 6.92823 4.34952 7.33754 5.06452 7.33754 C 5.78044 7.33754 8.06433 3.42822 8.77612 2.2251 C 8.90491 2.00785 9.18679 1.93451 9.40358 2.06422 C 9.62129 2.19256 9.6937 2.47351 9.56445 2.69168 C 9.22574 3.26506 6.56144 8.25421 5.06452 8.25421 Z"
      fill={fill}
    />
  </svg>
);

export default ChackedIcon;